import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'airway-bill-numbers' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
